import { NavLink } from "@mantine/core";
import { Link } from "react-router";
import type { ObjectName } from "../../../utils/enums";
import { getLinkToComponentEditModal } from "../../../utils/getLinkToComponentEditModal";

interface ComponentOpenEditModalLinkProps {
  componentId: number;
  objectName: ObjectName;
  linkContent: React.ReactNode;
  useNavLink?: boolean;
  navLinkIcon?: React.ReactNode;
  projectId: string;
  siteId: number;
}

function ComponentOpenEditModalLink({
  componentId,
  objectName,
  linkContent,
  useNavLink,
  navLinkIcon,
  projectId,
  siteId
}: ComponentOpenEditModalLinkProps) {
  const path =
    getLinkToComponentEditModal(objectName, componentId, projectId, siteId) +
    `/general`;

  if (!path) return null;

  if (useNavLink) {
    const commonProps = {
      label: linkContent,
      leftSection: navLinkIcon
    };

    return <NavLink {...commonProps} component={Link} to={path} />;
  }

  return <Link to={path}>{linkContent}</Link>;
}

export { ComponentOpenEditModalLink };
